import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Link, useNavigate} from 'react-router-dom';
import OrderService from "../../../../../../API/orders/orders/organization/OrderService";
import AttributeUtil from "../../../../../../utils/orders/AttributeUtil";
import OrderUtil from "../../../../../../utils/orders/OrderUtil";
import DateTimeUtil from "../../../../../../utils/common/DateTimeUtil";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Tooltip} from "@mui/material";
import TextFieldObjectWithEntityList from "../../../../textfield/TextFieldObjectWithEntityList";
import OrderDatePicker from "../../../../datepicker/OrderDatePicker";
import Box from "@mui/material/Box";
import WorkerService from "../../../../../../API/orders/job/WorkerService";
import {BreadcrumbsComponent} from "../../../../breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import {EditLocalStoragePagesData} from "../../../../../../utils/EditLocalStoragePagesData";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {ruRU} from "@mui/x-date-pickers/locales";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import MenuItem from "@mui/material/MenuItem";
import ButtonExit from "../../../../button/ButtonExit";
import ButtonAdd from "../../../../button/ButtonAdd";
import ButtonCreate from "../../../../button/ButtonCreate";
import {constantsErrorMessages} from "../../../../../../Constants";
import ModalAlert from "../../../customer-detales/ModalAlert";
import {calcFilterData} from "../../../../../../utils/common/calcFilterData";
import {OrderConstructorTableFilterData} from "../../../../../../data/FilterTables/OrderConstructorTableFilterData";
import DateRangeFilter from "../../../../filter/DateRangeFilter";
import DataUtil from "../../../../../../utils/common/DataUtil";
import {EMPTY_CUSTOMER_NUMBER_FILTER, EMPTY_ORDER_NUMBER_FILTER, EMPTY_CUSTOMER_FILTER, EMPTY_HEADER_FILTER, EMPTY_ATTRIBUTES_FILTER, EMPTY_CONSTRUCTOR_FILTER, EMPTY_TECHNOLOGIST_FILTER, EMPTY_MODEL_FILTER} from "../../../../../../data/OrderStatus";
import OrderFolderNameCell from "../order/OrderFolderNameCell";
import {handlerExport} from "../../../../../../pages/common/settings/handlerExport";

const OrderConstructorTable = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [filteredData, setFilteredData] = useState(data)
    const [customerList, setCustomerList] = useState([]);
    const [constructorList, setConstructorList] = useState([]);
    const [technologistList, setTechnologistList] = useState([]);
    const [nameList, setNameList] = useState([]);
    const [modelList, setModelList] = useState([]);
    const [attributeList, setAttributeList] = useState([]);
    const [numberList, setNumberList] = useState([]);
    const [numberCustomerList, setNumberCustomerList] = useState([]);
    const [updateModalOpen, setUpdateModalOpen] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const [dateOfConstructorDocumentation, setDateOfConstructorDocumentationOfReceipt] = useState(null);
    const [dateOfTechnicalDocumentation, setDateOfTechnicalDocumentation] = useState(null);
    const [alertData, setAlertData] = useState({});
    const [currentEditRowId, setCurrentEditRowId] = useState(null);
    const [change, setChange] = useState(null);
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const [showColumnFilters, setShowColumnFilters] = useState(false)

    const handleShowColumnFilters = () => {
        setShowColumnFilters(!showColumnFilters)
        if (showColumnFilters) {
            handleSearchQuery([], data, null, true)
        }
    }
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`organization/constructors`, "pageSize", nextState.pageSize)
        }
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, OrderConstructorTableFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [OrderConstructorTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`organization/constructors`, "searchQuery", searchQuery)
            }
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`organization/constructors`]?.pageSize
        const searchQuery = pagesData[`organization/constructors`]?.searchQuery

        return {searchQuery, pageSize}
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const handleSubmitExport = () => {
        handlerExport(() => OrderService.downloadOrdersConstructors(), handleModalAlert)
    }
    const setLists = (data) => {
        setCustomerList(DataUtil.getListField(data, 'customerName', EMPTY_CUSTOMER_FILTER));
        setConstructorList(DataUtil.getListChildField(data, 'constructor', 'name', EMPTY_CONSTRUCTOR_FILTER));
        setTechnologistList(DataUtil.getListChildField(data, 'technologist', 'name', EMPTY_TECHNOLOGIST_FILTER));
        setNameList(DataUtil.getListChildField(data, 'header', 'name', EMPTY_HEADER_FILTER));
        setAttributeList(OrderUtil.getStatuses(data, 'attributes', EMPTY_ATTRIBUTES_FILTER));
        const models = new Set();
        let hasEmptyModel = false;
        for (const row of data || []) {
            const names = (row.estimate?.modules || [])
                .map((module) => module?.originalName)
                .filter(Boolean);
            if (names.length === 0) {
                hasEmptyModel = true;
            } else {
                names.forEach((name) => models.add(name));
            }
        }
        if (hasEmptyModel) {
            models.add(EMPTY_MODEL_FILTER);
        }
        setModelList(Array.from(models));
        setNumberList(DataUtil.getListField(data, 'number', EMPTY_ORDER_NUMBER_FILTER));
        setNumberCustomerList(DataUtil.getListField(data, 'numberCustomer', EMPTY_CUSTOMER_NUMBER_FILTER));
    }
    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        OrderService.getOrdersConstructors().then(function (response) {
            const data = response.data
            setData(data);
            handleSearchQuery(searchQuery, data, pageSize)
            setLists(data)
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [change]);

    const handleUpdate = (row, values) => {
        data[row[currentEditRowId]] = values;
        setData([...data]);
        handleSearchQuery(globalFilter, [...data])
        setLists(data)
    };

    const handleUpdateModel = useCallback(
        (row) => {
            setCurrentEditRowData(row);
            setDateOfConstructorDocumentationOfReceipt(row.dateOfConstructorDocumentation);
            setDateOfTechnicalDocumentation(row.dateOfTechnicalDocumentation)
            setCurrentEditRowId(row.id);
            setUpdateModalOpen(true);
        },
        [data, currentEditRowData, setCurrentEditRowData],
    );

    const columns = useMemo(
        () => [
            {
                id: "number",
                header: 'Номер заказа',
                accessorKey: 'number',
                filterVariant: 'multi-select',
                filterSelectOptions: numberList,
                enableEditing: false,
                maxSize: 23,
                minSize: 35,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по № заказа',
                    sx: {width: '200px'},
                },
                Cell: ({cell, row}) => {
                    const headerValue = row.original.header;
                    let header = null
                    if (headerValue !== null) {
                        header = headerValue.id;
                    }
                    return (
                        <OrderFolderNameCell order={row.original}>
                            <Tooltip arrow placement="bottom" title={row.original.number}>
                                <Box
                                    sx={{
                                        width: "130px",
                                        overflow: "clip",
                                        textOverflow: "ellipsis"
                                    }}
                                >
                                    <Link
                                        to={'/organization/constructors/' + row.original.id + '/' + encodeURIComponent(cell.getValue()) + '/' + header + '/' + row.original.year}
                                    >
                                        {cell.getValue() === null ? 'Не занумерован' : cell.getValue()}
                                    </Link>
                                </Box>
                            </Tooltip>
                        </OrderFolderNameCell>
                    );
                },
            },
            {
                id: 'numberCustomer',
                header: 'Номер заказчика',
                accessorKey: 'numberCustomer',
                filterVariant: 'multi-select',
                filterSelectOptions: numberCustomerList,
                maxSize: 23,
                minSize: 35,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по № заказчика',
                    sx: {width: '200px'},
                },
            },
            {
                id: 'customerName',
                header: 'Заказчик',
                accessorKey: 'customerName',
                enableStickyHeader: true,
                enableStickyFooter: true,
                enableGrouping: true,
                enableEditing: false,
                filterVariant: 'multi-select',
                filterSelectOptions: customerList,
                minSize: 200,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по заказчик',
                    sx: {
                        width: '200px',
                    },
                }
            },
            {
                id: 'header',
                header: 'Наименование',
                accessorFn: (row) => row.header?.name,
                filterVariant: 'multi-select',
                filterSelectOptions: nameList,
                enableGrouping: true,
                enableEditing: false,
                minSize: 15,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по наименование',
                    sx: {
                        width: '200px',
                    },
                }
            },
            {
                id: 'models',
                header: 'Модели',
                accessorFn: (row) => (row.estimate?.modules || [])
                    .map((module) => module?.originalName)
                    .filter(Boolean)
                    .join(', '),
                filterVariant: 'multi-select',
                filterSelectOptions: modelList,
                enableGrouping: true,
                enableEditing: false,
                size: Math.max(
                    80,
                    ...['Модели', ...(modelList || []).filter((name) => name !== EMPTY_MODEL_FILTER)]
                        .map((name) => String(name).length * 9)
                ),
                Cell: ({row}) => {
                    const names = (row.original.estimate?.modules || [])
                        .map((module) => module?.originalName)
                        .filter(Boolean);
                    if (!names.length) {
                        return null;
                    }
                    return (
                        <Box sx={{display: 'flex', flexDirection: 'column', whiteSpace: 'nowrap'}}>
                            {names.map((name, index) => (
                                <Box key={`${name}-${index}`}>{name}</Box>
                            ))}
                        </Box>
                    );
                },
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по модели',
                    sx: {
                        width: '200px',
                    },
                }
            },
            {
                accessorFn: (row) => {
                    if (row.dateOfReceipt == null) {
                        return undefined;
                    }
                    return new Date(row.dateOfReceipt);
                },
                id: 'dateOfReceipt',
                header: 'Поступление',
                sortingFn: 'datetime',
                minSize: 120,
                enableEditing: false,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                id: 'attributes',
                header: 'Атрибуты',
                accessorKey: 'attributes',
                filterVariant: 'multi-select',
                filterSelectOptions: attributeList,
                filterFn: (row, id, filterValue) => {
                    return OrderUtil.checkStatus(row.getValue(id), filterValue)
                },
                minSize: 20,
                enableEditing: false,
                Cell: ({cell, row}) => (
                    <Link
                        to={'/organization/orders/set-attribute/' + row.original.id + '/' + encodeURIComponent(row.original.number) + '/' + row.original.header.id}
                    >{row.original.attributes.length === 0 ? 'Не устанволен' : AttributeUtil.convertAttributes(cell.getValue())}</Link>
                ),
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по заказчик',
                    sx: {
                        width: '200px',
                    },
                }

            },
            {
                accessorFn: (row) => {
                    if (row.dateOfPlannedProduction === null) {
                    } else {
                        return new Date(row.dateOfPlannedProduction)
                    }
                },
                id: 'dateOfPlannedProduction',
                header: 'Плановая дата произодства',
                sortingFn: 'datetime',
                minSize: 150,
                enableEditing: false,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                id: 'constructor',
                header: 'Констуктор',
                accessorKey: 'constructor.name',
                enableStickyHeader: true,
                enableStickyFooter: true,
                enableGrouping: true,
                filterVariant: 'multi-select',
                filterSelectOptions: constructorList,
                maxSize: 100,
                minSize: 100,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по конструктор',
                    sx: {
                        width: '100px',
                    },
                }
            },
            {
                accessorFn: (row) => {
                    if (row.dateOfConstructorDocumentation === null) {
                    } else {
                        return new Date(row.dateOfConstructorDocumentation)
                    }
                },
                id: 'dateOfConstructorDocumentation',
                header: 'Дата тех. документации конструктор',
                sortingFn: 'datetime',
                minSize: 250,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                id: 'technologist',
                header: 'Технолог',
                accessorKey: 'technologist.name',
                enableStickyHeader: true,
                enableStickyFooter: true,
                enableGrouping: true,
                filterVariant: 'multi-select',
                filterSelectOptions: technologistList,
                maxSize: 20,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по заказчик',
                    sx: {
                        width: '200px',
                    },
                }
            },
            {
                accessorFn: (row) => {
                    if (row.dateOfTechnicalDocumentation === null) {
                    } else {
                        return new Date(row.dateOfTechnicalDocumentation)
                    }
                },
                id: 'dateOfTechnicalDocumentation',
                header: 'Дата тех. документации технолог',
                sortingFn: 'datetime',
                minSize: 250,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableEditing: false,
            },
        ],
        [data, setData, filteredData, customerList, nameList, modelList, attributeList, constructorList, technologistList, numberList, numberCustomerList],
    );

    const menuItem = [
        {type: "edit", text: "Редактировать", handler: handleUpdateModel}]

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Проектирование"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>
            <Box sx={{maxWidth: "2500px", display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Проектирование
                    </Typography>
                </Box>
                <Box
                    sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
                >
                    <Box sx={{display: 'flex', justifyContent: "spase-between", gap: "9px"}}>
                        <ButtonCreate
                            text={"Экспорт"}
                            width={80}
                            icon={false}
                            onClick={handleSubmitExport}
                        />
                        <ButtonCreate
                            text={"Разработано"}
                            width={120}
                            icon={false}
                            onClick={() => navigate('/organization/constructors/developed')}
                        />

                    </Box>
                </Box>
                <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale='ru'
                    localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}>
                    <MaterialReactTable
                        muiTableContainerProps={{
                            sx: {
                                maxHeight: `calc(100vh - 450px)`,
                            }
                        }}
                        muiTopToolbarProps={{
                            sx: {
                                "& .MuiBox-root": {
                                    padding: 0
                                }
                            }
                        }}
                        muiTableBodyCellProps={{
                            sx: {
                                p: '0px 0px 0px 10px',
                                m: '0px 0px 0px 0px',
                                border: "none",
                                "&:after": {
                                    display: "none",
                                },
                                "&:not(:last-of-type)": {
                                    borderRight: '1px solid #EAEBEA',

                                },
                                "&:first-of-type": {
                                    padding: 0,
                                    width: "50px",
                                    height: "36px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: (theme) => theme.palette.text.light,
                                    "& .MuiButtonBase-root": {
                                        borderRadius: "4px",
                                        width: "24px",
                                        height: "24px",
                                        opacity: 1,
                                        margin: 0,
                                        padding: 0,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        }
                                    }
                                },
                                "& a": {
                                    color: "#006CCC",
                                    textDecoration: "none",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }

                                }
                            },
                        }}
                        muiTableHeadCellProps={{
                            sx: {
                                border: '1px solid #EAEBEA',
                                backgroundColor: "#F5F6FA",
                                padding: "10px",
                                paddingBottom: " 0.2rem",
                                paddingTop: "0.2rem",
                                "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                                    "minWidth": "100%"
                                },
                                "& .MuiCollapse-root .MuiSelect-select": {
                                    padding: "0 !important",
                                    "& .MuiChip-label": {
                                        paddingLeft: "5px",
                                        paddingRight: "5px",
                                    }
                                }
                            },
                        }}
                        muiTableBodyRowProps={({row}) => {
                            return ({
                                sx: () => ({
                                    height: 'auto',
                                    minHeight: '36px',
                                    backgroundColor: "white",
                                    "&:hover& td:after": {
                                        display: "none",
                                    },
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light70,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    "&:hover": {
                                        "& td:after": {
                                            display: "none",
                                        },
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                    '&:nth-of-type(even)': {
                                        "&.MuiTableRow-root.Mui-selected": {
                                            backgroundColor: (theme) => theme.palette.primary.light,
                                            "&:hover": {
                                                backgroundColor: (theme) => theme.palette.primary.light50,
                                            },
                                        },
                                        backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        },
                                    },
                                })
                            })
                        }}

                        muiSearchTextFieldProps={{
                            placeholder: `Поиск`,
                            sx: {
                                paddingTop: "5px",
                                paddingBottom: "0px",
                                "& .MuiCollapse-root": {
                                    borderRadius: '12px',
                                    height: 40, width: 290,
                                    "& .MuiSvgIcon-root": {
                                        color: "#737478"
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        padding: 0
                                    }
                                }
                            },
                            variant: 'outlined',
                        }}
                        displayColumnDefOptions={{
                            'mrt-row-actions': {
                                header: "",
                                size: 3,
                                minSize: 3,
                                grow: false,
                            },
                        }}
                        columns={columns}
                        data={filteredData}
                        onPaginationChange={(updater) => {
                            tableOptionsHandle(updater(tableOptions));
                        }}
                        onGlobalFilterChange={(value) => {
                            handleSearchQuery(value, data, null)
                        }}
                        onColumnFiltersChange={(updater) => {
                            handleSearchQuery(updater(columnsFilter), data, null, true)
                        }}
                        onShowColumnFiltersChange={handleShowColumnFilters}
                        state={{
                            showColumnFilters: showColumnFilters,
                            columnFilters: columnsFilter,
                            globalFilter: globalFilter,
                            showGlobalFilter: true,
                            pagination: tableOptions,
                        }}
                        manualFiltering={true}
                        rowCount={tableOptions.totalElements}
                        initialState={{
                            columnVisibility: {
                                id: false,
                            },
                        }}
                        muiToolbarAlertBannerChipProps={{color: 'primary'}}
                        localization={MRT_Localization_RU}
                        enableRowActions={true}
                        enableToolbarInternalActions={false}
                        selectAllMode={"all"}
                        getRowId={(originalRow) => originalRow.id}
                        renderTopToolbar={({table}) => {
                            return <Box sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "7px",
                                backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                            }}>
                                <MRT_ToolbarAlertBanner table={table}/>
                                <Box sx={{display: "flex"}}>
                                    <MRT_ToggleFiltersButton table={table}/>
                                    <MRT_GlobalFilterTextField table={table}/>
                                </Box>
                            </Box>
                        }}
                        muiToolbarAlertBannerProps={{
                            sx: {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "& .MuiStack-root": {
                                    padding: 0,
                                },
                            }
                        }}
                        renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                            return <MenuItem
                                key={el.type}
                                onClick={() => {
                                    el.handler(row.original)
                                    closeMenu();
                                }}
                                sx={{
                                    margin: "0 8px",
                                    borderRadius: "4px",
                                    "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                                }}
                            >
                                {el.text}
                            </MenuItem>
                        })}
                    />
                </LocalizationProvider>
            </Box>
            <UpdateOrderModalConstructor
                open={updateModalOpen}
                onClose={() => setUpdateModalOpen(false)}
                onSubmit={handleUpdate}
                values={currentEditRowData}
                currentEditRowId={currentEditRowId}
                change={change}
                setChange={setChange}
                setValues={setCurrentEditRowData}
                dateOfConstructorDocumentation={dateOfConstructorDocumentation}
                setDateOfConstructorDocumentationOfReceipt={setDateOfConstructorDocumentationOfReceipt}
                dateOfTechnicalDocumentation={dateOfTechnicalDocumentation}
                setDateOfTechnicalDocumentation={setDateOfTechnicalDocumentation}
                handleModalAlert={handleModalAlert}
            />
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};

export const UpdateOrderModalConstructor = ({
                                                open, onClose,
                                                onSubmit,
                                                values,
                                                setValues,
                                                change,
                                                setChange,
                                                dateOfConstructorDocumentation,
                                                setDateOfConstructorDocumentationOfReceipt,
                                                dateOfTechnicalDocumentation,
                                                setDateOfTechnicalDocumentation,
                                                handleModalAlert
                                            }) => {

    const [constructorList, setConstructorList] = useState([]);
    const [constructorId, setConstructorId] = useState(null);
    const [technologistId, setTechnologistId] = useState(null);
    const [loading, setLoading] = useState(false)

    useEffect(() => {

        WorkerService.getAllEnabledAndConstructor().then(function (response) {
            let data = response.data;
            setConstructorList(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);


    const handleSubmit = () => {
        setLoading(true)
        values.dateOfConstructorDocumentation = dateOfConstructorDocumentation === null ?
            null : DateTimeUtil.dateConvert(dateOfConstructorDocumentation);
        values.dateOfTechnicalDocumentation = dateOfTechnicalDocumentation === null ?
            null : DateTimeUtil.dateConvert(dateOfTechnicalDocumentation);

        OrderService.updateConstructor(values,
            constructorId === null ?
                (constructorList === null ? null : constructorList[0].id) : constructorId,
            technologistId === null ?
                (constructorList === null ? null : constructorList[0].id) : technologistId,
        ).then(function (response) {
            onSubmit(response.data);
            setChange(!change)
            onClose();
            handleModalAlert("Заказ изменён", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    };

    return (
        <Dialog open={open}>
            <DialogTitle textAlign="center">Редактировать заказ</DialogTitle>
            <DialogContent sx={{padding: "0 20px"}}>
                <Stack
                    sx={{
                        width: '100%',
                        minWidth: {xs: '300px', sm: '360px', md: '400px'},
                    }}
                >
                    <TextFieldObjectWithEntityList
                        label="Конструктор"
                        values={values}
                        field={'constructor'}
                        setId={setConstructorId}
                        entityList={constructorList}
                    />
                    <OrderDatePicker
                        label={'Дата тех. документации конструктор'}
                        date={dateOfConstructorDocumentation}
                        setDate={setDateOfConstructorDocumentationOfReceipt}
                    />
                    <TextFieldObjectWithEntityList
                        label="Технолог"
                        values={values}
                        field={'technologist'}
                        setId={setTechnologistId}
                        entityList={constructorList}
                    />
                    <OrderDatePicker
                        label={'Дата тех. документации технолог'}
                        date={dateOfTechnicalDocumentation}
                        setDate={setDateOfTechnicalDocumentation}
                    />
                </Stack>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Выйти"} onClick={onClose}/>
                <ButtonAdd loading={loading} text={"Сохранить"} onClick={handleSubmit}/>
            </DialogActions>
        </Dialog>
    );
};

export default OrderConstructorTable;